import { BodyText } from 'src/viewLayer/components/DesignSystem';

import TextWithInterpolation from 'src/viewLayer/components/shared/TextWithInterpolation';
import { t } from 'src/viewLayer/helpers/translations';
import '../index.scss';
import { FootnoteContainer } from './index.styled';

export default ({ footnote }: { footnote: { key: string } }): JSX.Element => (
  <FootnoteContainer>
    <BodyText textAlign="center" size="small">
      { TextWithInterpolation({ translationText: t(footnote.key) }) }
    </BodyText>
  </FootnoteContainer>
);
